import { render, staticRenderFns } from "./workshop.vue?vue&type=template&id=5775e253"
import script from "./workshop.vue?vue&type=script&lang=js"
export * from "./workshop.vue?vue&type=script&lang=js"
import style0 from "./workshop.vue?vue&type=style&index=0&id=5775e253&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports